import { axios } from './index'
const resource = '/v1/stay/users'
const resource_stay = '/v1/stay'

export default {
  /**
   * ユーザー個人情報を取得する
   */
  postUser() {
    return axios.post(`${resource_stay}/users/my`)
  },
  /**
   * ユーザー個人情報を取得する
   */
  getUser() {
    return axios.get(`${resource_stay}/profile/me`)
  },
  /**
   * ユーザー情報更新
   */
  updateUser(formData) {
    const headers = {
      'Content-Type': 'multipart/form-data'
    }
    return axios.put(`${resource_stay}/users/member-info`, formData, headers)
    // return axios({
    //   method: 'PUT',
    //   url: `${resource}/member-info`,
    //   data: formData,
    //   headers
    // })
  },

  contractInfo(boCode) {
    /**
     * SSO 認証対応
     */
    if (boCode == "BS") {
      return axios.post(`${resource}/contract-info?bo-code=${boCode}`);
    } else {
      return axios.post(`${resource}/contract-info`)
    }
  },

  logout() {
    return axios.get(`${resource_stay}/logout`)
  },
  getUserAddress() {
    return new Promise((resolve) => {
      axios.get(`${resource_stay}/profile/member/address`).then(
        (response) => {
          resolve(response.data.addresses)
        },
        (error) => {
          resolve(error)
        }
      )
    })
  },
  updateUserAddress(data) {
    return axios.put(`${resource_stay}/profile/member/address`, data)
  },
  async getPointHistory({ pointFrom, pointTo, startIndex, count, commandType }) {
    let params = {
      pointFrom,
      pointTo,
      startIndex,
      count,
      commandType
    }
    if (!pointFrom && pointTo) {
      params = {
        pointTo,
        startIndex,
        count,
        commandType
      }
    }
    if (!pointTo && pointFrom) {
      params = {
        pointFrom,
        startIndex,
        count,
        commandType
      }
    }
    if (!pointTo && !pointFrom) {
      params = {
        startIndex,
        count,
        commandType
      }
    }
    if (!commandType && pointFrom && pointTo) {
      params = {
        pointFrom,
        pointTo,
        startIndex,
        count
      }
    }
    if (!commandType && !pointFrom && !pointTo) {
      params = {
        startIndex,
        count
      }
    }
    return axios.get(`${resource_stay}/member/point/history`, { params })
  },
  async getCafePoint() {
    return axios.get(
      `${resource_stay}/cafePoint/appliablePoint`
    );
  }
}
